export const CREATE_ANNUAL_LEAVE = "CREATE_ANNUAL_LEAVE";
export const FETCH_ANNUAL_LEAVES = "FETCH_ANNUAL_LEAVES";
export const FETCH_ANNUAL_LEAVE = "FETCH_ANNUAL_LEAVE";
export const EDIT_ANNUAL_LEAVE = "EDIT_ANNUAL_LEAVE";
export const DELETE_ANNUAL_LEAVE = "DELETE_ANNUAL_LEAVE";
